/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-wall': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M238 56H62a6 6 0 00-6 6v176a6 6 0 006 6h176a6 6 0 006-6V62a6 6 0 00-6-6zm-30 180h-56v-24h56zm-116 0v-24h56v24zM236 64v24h-54V64zm0 84h-54v-26h54zm-28 30h-56v-26h56zm-30 30h-56v-26h56zM64 122h54v26H64zm28-30h56v26H92zm86 56h-56v-26h56zm-86 4h56v26H92zm116-34h-56V92h56zm-30-54v24h-56V64zm-60 24H64V64h54zm-30 4v26H64V92zm0 60v26H64v-26zm-24 30h54v26H64zm118 26v-26h54v26h-54zm30-30v-26h24v26zm0-60V92h24v26zM64 212h24v24H64zm148 24v-24h24v24z"/>'
  }
})
